import { Component, ChangeDetectorRef } from '@angular/core';

import { ButtonComponent, TempModalComponent } from '@program-suite/ui';
import { ModalService, ModalType } from '@program-suite/ui';
import { DashboardService } from '@program-suite/data-common';

@Component({
  selector: 'lib-feature-program-guidelines',
  imports: [ButtonComponent],
  templateUrl: './feature-program-guidelines.component.html',
  styleUrl: './feature-program-guidelines.component.scss',
})
export class ProgramGuidelinesComponent {
  programTiles: any[] = [];

  constructor(
    private dashaboardService: DashboardService,
    private cdr: ChangeDetectorRef,
    private modalService: ModalService,
    ) {
    this.loadProgramTiles();
  }

  toggleAdvertisement() {
     this.modalService.open(TempModalComponent, {
          modalType: ModalType.Small,
      });
  }

  async loadProgramTiles() {
    try {
      const result = await this.dashaboardService.getProgramTiles();
      this.programTiles = Array.isArray(result) ? result : [];
      this.cdr.markForCheck();
    } catch (error) {
      this.programTiles = [];
    }
  }

  getListItems(subHeading: string): string[] {
    return subHeading.split(', ');
  }
}
